import { render, staticRenderFns } from "./AddEditEvent.vue?vue&type=template&id=183f8ea9&"
import script from "./AddEditEvent.vue?vue&type=script&lang=js&"
export * from "./AddEditEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports